/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React from 'react';
import { ResultsStatus } from '@src/common/types';
import { riskScoresId } from '../../types';
import { useRiskScoreResultsStore } from '../../mothership/riskScoresResults.state';

/*
  Only re-render this component when loading changes
*/
export const RiskAnalysisLoadingAttr = () => {
  const resultsStatus = useRiskScoreResultsStore((state) => state.resultStatus);
  const loading = resultsStatus === ResultsStatus.searching;
  const id = `${riskScoresId}FilterPanel`;
  return (
    <div
      data-cy={id}
      data-loading={loading}
      data-results-state={resultsStatus}
    ></div>
  );
};
